module.exports = __webpack_public_path__ + "static/HKGrotesk-Bold-048f35d281757b84e9c2d1a9dd2b40a8.woff2";